import {FilterChecked}							from '../components/Modal/interface';

import {Device, DevicesState}					from '../../redux/devices/interface';
import {User}									from '../../redux/user/interface';
import {Order, OrderAddressList}				from '../../redux/order/interface';
import {Contract}						from '../../redux/contracts/interface';
import {ContractNotValala}						from '../../redux/contractsNotValala/interface';
import {Support}								from '../../redux/support/interface';
import {CatalogMinimal}							from '../../redux/catalog/interface';
import {MdmDevice}								from '../../redux/devices/interfaceMdm';

import {ft_getDeviceStatus}						from './deviceFunction';
import {ft_formatFirstLowerCase,
	ft_formatUserName}							from './format';
import {ft_getContractStatus}					from './contractFunction';
import {MobileLine} from '../../redux/mobileLines/interface';


export function ft_checkDeviceFilters(filters: FilterChecked[], device: Device, users: User[], devicesMdm?: DevicesState['mdm']): boolean {
	if (!device)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'type' && !filterData.values.find(find => find === device.shopData?.type || find === device.notValalaData?.deviceType))
			isValid = false;
		if (filterData.key === 'status' && !filterData.values.find(find => find === ft_getDeviceStatus(device, users)))
			isValid = false;
		if (filterData.key === 'isValala' && !filterData.values.find(find => (find === 'valala' ? !device.notValala : device.notValala)))
			isValid = false;
		if (filterData.key === 'tags' && !filterData.values.find(find => device.tags?.find(tag => tag === find)))
			isValid = false;
		if (filterData.key === 'supplier' && !filterData.values.find(find => (find === 'Valala' && !device.notValala) || find === device.notValalaData?.funder))
			isValid = false;
		if (filterData.key === 'mdm') {
			if (!devicesMdm)
				isValid = false;
			else if (!filterData.values.some(find => devicesMdm[ft_formatFirstLowerCase(find) as keyof DevicesState['mdm']].some(mdm => mdm.serial === device.serial)))
				isValid = false;
		}
	});

	return isValid;
}

export function ft_checkMobileLineFilters(filters: FilterChecked[], mobileLine: MobileLine): boolean {
	if (!mobileLine)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'status' && !filterData.values.find(find => find === mobileLine.lineData?.status))
			isValid = false;
		if (filterData.key === 'tags' && !filterData.values.find(find => mobileLine.tags?.find(tag => tag === find)))
			isValid = false;
	});

	return isValid;
}

export function ft_checkOrderFilters(filters: FilterChecked[], orderAddress: OrderAddressList) {
	const findStatus = (value: string) => {
		if (value === 'refusedByFunder' || value === 'refuserByValala')
			return orderAddress.status.name === 'refusedByFunder' || orderAddress.status.name === 'refusedByValala';
		if (value === 'inPreparation')
			return orderAddress.status.name.startsWith('inPreparation');
		return value === orderAddress.status.name;
	};

	if (!orderAddress)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'status' && !filterData.values.find(findStatus))
			isValid = false;
	});

	return isValid;
}

export function ft_checkContractFilters(filters: FilterChecked[], contract: (Contract | ContractNotValala)) {
	if (!contract)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'isValala' && !filterData.values.find(find => (find === 'valala' && 'funderList' in contract) || (find === 'notValala' && !('funderList' in contract))))
			isValid = false;
		if (filterData.key === 'tags' && !filterData.values.find(find => contract.tags?.find(tag => tag === find)))
			isValid = false;
		if (filterData.key === 'status' && !filterData.values.find(find => find === ft_getContractStatus(contract)))
			isValid = false;
	});

	return isValid;
}

export function ft_checkSupportFilters(filters: FilterChecked[], support: Support): boolean {
	if (!support)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'status' && !filterData.values.find(find => find === support.status))
			isValid = false;
	});

	return isValid;
}

export function ft_checkUsersFilters(filters: FilterChecked[], user: User): boolean {
	if (!user)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'tags' && !filterData.values.find(find => user.tags.find(tag => tag === find)))
			isValid = false;
	});

	return isValid;
}

export function ft_checkMdmDeviceFilters(filters: FilterChecked[], device: MdmDevice): boolean {
	if (!device)
		return false;

	let isValid = true;

	filters.forEach((filterData) => {
		if (!isValid)
			return;
		if (filterData.key === 'type' && !filterData.values.find(find => find === device.type))
			isValid = false;
	});

	return isValid;
}

export function ft_sortOrderByDate(data: Order[], sort: string) {
	if (!sort || !data)
		return data;

	return [...data].sort((a, b) => {
		if (sort === 'sortRecent')
			return new Date(b.data.creationDate).valueOf() - new Date(a.data.creationDate).valueOf();
		return new Date(a.data.creationDate).valueOf() - new Date(b.data.creationDate).valueOf();
	});
}

export function ft_sortUsers(users: User[], sort: string) {
	if (!sort || !users)
		return users;

	return [...users].sort((a, b) => {
		if (sort === 'job-AtoZ')
			return (a?.job || '').localeCompare(b?.job || '');
		if (sort === 'job-ZtoA')
			return (b?.job || '').localeCompare(a?.job || '');
		if (sort === 'sortAtoZ' || sort === 'name-AtoZ')
			return ft_formatUserName(a).localeCompare(ft_formatUserName(b));
		return ft_formatUserName(b).localeCompare(ft_formatUserName(a));
	});
}

export function ft_sortContractByDate(data: (Contract | ContractNotValala)[], sort: string) {
	if (!sort || !data)
		return data;

	return [...data].sort((a, b) => {
		if (!a.data)
			return -1;
		if (!b.data)
			return 1;
		if (sort === 'sortRecent')
			return new Date(b.data.creationDate).valueOf() - new Date(a.data.creationDate).valueOf();
		return new Date(a.data.creationDate).valueOf() - new Date(b.data.creationDate).valueOf();
	});
}

export function ft_sortSupportByDate(data: Support[], sort: string) {
	if (!sort || !data)
		return data;

	return [...data].sort((a, b) => {
		if (sort === 'sortRecent')
			return new Date(b.data.creationDate).valueOf() - new Date(a.data.creationDate).valueOf();
		return new Date(a.data.creationDate).valueOf() - new Date(b.data.creationDate).valueOf();
	});
}

export function ft_sortCatalogByPrice(data: CatalogMinimal[], sort: string, favorite: string[]) {
	if (!data)
		return data;

	return [...data].sort((a, b) => {
		const aFav = favorite.some(e => e === a.category?._id);
		const bFav = favorite.some(e => e === b.category?._id);

		if (aFav && !bFav)
			return -1;
		if (!aFav && bFav)
			return 1;

		if (sort === 'decreasingPrice')
			return b.lowestPrice - a.lowestPrice;
		if (sort === 'ascendingPrice')
			return a.lowestPrice - b.lowestPrice;
		return 0;
	});
}